	export enum RecommendationSideEnum {
		Right = 1,
		Left = 2,
		Binaural = 3,
		None = 4
	}
